import React from "react";
import Logout from "../../../logout/Logout";
import styles from "../../../../assets/css/modules/information/errors/sharedErrorContent/error-content-links.css";

export const ErrorContentLinks = () => {
  return (
    <p className={styles.sharedErrorContent}>
      <Logout />
    </p>
  );
};
export default ErrorContentLinks;
